import React, { useState, useEffect, useCallback } from 'react';
import { Modal } from 'shared/components/ui';
import { pagosFacturasAPI } from '../services/pagosFacturasAPI';
import { Toast } from '../../../shared/components/Toast';
import './VisorConstancia.css';

const VisorConstancia = ({ isOpen, onClose, factura }) => {
  const [objectUrl, setObjectUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const limpiarUrl = useCallback(() => {
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl);
      setObjectUrl(null);
    }
    setFileType(null);
  }, [objectUrl]);

  useEffect(() => {
    if (!isOpen || !factura?.idConstancia) return;

    let revoked = false;
    let currentUrl = null;

    const cargarConstancia = async () => {
      setLoading(true);
      setToast(null);
      try {
        const response = await pagosFacturasAPI.verConstancia(factura.idConstancia);
        if (revoked) return;

        const blob = response.data;
        const tipo = blob.type;
        const url = URL.createObjectURL(blob);
        currentUrl = url;
        setObjectUrl(url);
        setFileType(tipo);
      } catch {
        if (!revoked) {
          setToast({ message: 'No se pudo cargar la constancia de pago', type: 'error' });
        }
      } finally {
        if (!revoked) {
          setLoading(false);
        }
      }
    };

    cargarConstancia();

    return () => {
      revoked = true;
      if (currentUrl) {
        URL.revokeObjectURL(currentUrl);
      }
    };
  }, [isOpen, factura]);

  useEffect(() => {
    if (!isOpen) {
      limpiarUrl();
    }
  }, [isOpen, limpiarUrl]);

  if (!isOpen) return null;

  const esImagen = fileType === 'image/jpeg' || fileType === 'image/png';
  const esPdf = fileType === 'application/pdf';

  return (
    <>
      <Modal show={isOpen} onHide={onClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Constancia de Pago — Factura Nº {factura?.nroFactura || ''}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="visor-constancia-body" style={{ minHeight: '60vh' }}>
            {loading && (
              <div className="visor-constancia-loading">
                <span>Cargando constancia...</span>
              </div>
            )}

            {!loading && objectUrl && esImagen && (
              <img
                src={objectUrl}
                alt={`Constancia de pago - Factura ${factura?.nroFactura || ''}`}
                className="visor-constancia-imagen"
              />
            )}

            {!loading && objectUrl && esPdf && (
              <iframe
                src={objectUrl}
                title={`Constancia de pago - Factura ${factura?.nroFactura || ''}`}
                className="visor-constancia-pdf"
              />
            )}

            {!loading && !objectUrl && !toast && (
              <div className="visor-constancia-loading">
                <span>No se pudo mostrar la constancia</span>
              </div>
            )}
          </Modal.Body>
      </Modal>

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};

export default VisorConstancia;
